import React, { Fragment } from "react";
import Nums from "./Nums";

const Numbers = () => {
  const FOOTER1 = {
    Title: "",
    Type: "Primzahlen ",
    Examples: {
      1: ["null", "nol : 0"],
      2: ["eins", "ainz : 1"],
      3: ["zwei", "etsvai : 2"],
      4: ["drei", "deghai : 3"],
      5: ["vier", "fiya : 4"],
      6: ["fünf", "fonf : 5"],
      7: ["sechs", "zeks : 6"],
      8: ["sieben", "ziben : 7"],
      9: ["acht", "akht : 8"],
      10: ["neun", "noin : 9"],
      11: ["zehn", "sin : 10"],
    },
  };
  const FOOTER2 = {
    Title: "",
    Type: "Zweite",
    Examples: {
      1: ["elf", "elf : 11"],
      2: ["zwölf", "etsvolf : 12"],
    },
  };
  const FOOTER3 = {
    Title: "",
    Type: "Dritte",
    Examples: {
      1: ["dreizehn", "deghaisin : 13"],
      2: ["vierzehn", "viyasin : 14"],
      3: ["fünfzehn", "fonfsin : 15"],
      4: ["sech-zehn", "zeksin : 16"],
      5: ["sieb-zehn", "zibsin : 17"],
      6: ["achtzehn", "akhtsin : 18"],
      7: ["neunzehn", "noinsin : 19"],
      8: ["zwanzig", "etsvansish : 20"],
      9: ["zwei-und-zwanzig", "etsvansish : 20"],
    },
  };
  const FOOTER4 = {
    Title: "",
    Type: "Vierte",
    Examples: {
      1: ["zwanzig", "etsvansish : 20"],
      2: ["dreißig", "deghaisish : 3"],
      3: ["vierzig", "viyasish : 40"],
      4: ["füngzig", "fonfsish : 50"],
      5: ["sech-zig", "zeksish : 60"],
      6: ["sieb-zig", "sebsish : 70"],
      7: ["achtzig", "akhtsish : 80"],
      8: ["neunzig", "noinsish : 90"],
    },
  };
  const FOOTER5 = {
    Title: "",
    Type: "Fünfte",
    Examples: {
      1: ["hundert", "hondat : 100"],
      2: ["zwei+hundert", "etsvaihondat : 200"],
      3: ["drei+hundert", "deghaihondat : 300"],
      4: ["vier+hundert", "viyahondat : 400"],
      5: ["fünf+hundert", "fonfhondat : 500"],
      6: ["sechs+hundert", "zekshondat : 600"],
      7: ["sieben+hundert", "zibenhondat : 700"],
      8: ["acht+hundert", "akhthondat : 800"],
      9: ["neun+hundert", "noinhondat : 900"],
    },
  };
  const FOOTER6 = {
    Title:
      "یک قائده کلی برای به دست آوردن اعداد  بالا تر از 20 وجود داره که باید یاد گرفت : اعداد اول + und + دسته سوم به بعد",
    Type: "",
    Examples: {
      1: ["ein.und.zwanzig", "21"],
      2: ["ein.und.dreißig", "31"],
      3: ["ein.und.siebzig", "71"],
      4: ["neun.und.neunzig", "99"],
      5: ["sieben.und.achtzig", "87"],
      6: ["acht.und.achtzig", "88"],
      7: ["sechs.hundert.neun.und.neunzig", "699"],
      8: ["drei.hundert.drei.und.achtzig", "383"],
      9: ["vier.hundert.achtzehn", "418"],
      10: ["zwei.hundert.fünf", "205"],
      11: ["ein.hundert.eins", "101"],
      12: ["zwei.hundert.eins", "201"],
      13: [
        "fünf Millionen fünfhundertfünfundfünfzigtausend fünfhundertfünfundfünfzig",
        "5555555",
      ],
    },
  };

  return (
    <Fragment>
      <Nums FOOTER={FOOTER1} B="" B1="" B2="" />
      <Nums FOOTER={FOOTER2} B="" B1="" B2="" />
      <Nums FOOTER={FOOTER3} B={[3, 4, 7, 8]} B1="#f7fcaf" B2="#affcd1" />
      <Nums FOOTER={FOOTER4} B={[4, 5]} B1="#f7fcaf" B2="" />
      <Nums FOOTER={FOOTER5} B="" B1="" B2="" />
      <Nums FOOTER={FOOTER6} B="" B1="" B2="" />
    </Fragment>
  );
};

export default Numbers;
